import { render, staticRenderFns } from "./jianli.vue?vue&type=template&id=77b507ba&scoped=true&"
import script from "./jianli.vue?vue&type=script&lang=js&"
export * from "./jianli.vue?vue&type=script&lang=js&"
import style0 from "./jianli.vue?vue&type=style&index=0&id=77b507ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b507ba",
  null
  
)

export default component.exports